var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext, useEffect, useState } from "react";
import { FieldType, PaymentSourceTypes, } from "@brushfire/types";
import { Accordion, Card, Col, Row } from "react-bootstrap";
import { Form, FadeSection, HorizontalRule, Styles, Alert } from "@brushfire/ui";
import BrushfireField from "@brushfire/ui/dist/Elements/Form/BrushfireField";
import { setFormIsSubmitting, setInlineError } from "../../store/AppState/actions";
import { useDispatch, useSelector } from "react-redux";
import { getDefaultCountry, getPaymentMethodId, log, Style } from "../../data/helpers";
import WidgetFieldset from "../Helpers/WidgetFieldset";
import * as Yup from "yup";
import FormikContextListener from "../Helpers/FormikContextListener";
import Constants from "../../data/constants";
import { WidgetContext } from "../Widget";
import { AppFormContext } from "../../App";
import Stripe from "./Stripe/Stripe";
import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import { isPossiblePhoneNumber } from "react-phone-number-input/input";
import InlineError from "../UI/InlineError";
import Square from "./Square/Square";
import StripeWalletButton from "./Stripe/StripeWalletButton";
import MaskedCardExpInput from "./UI/MaskedCardExpInput";
import Skeleton from "@material-ui/lab/Skeleton";
import { useIntl } from "react-intl";
import ReactSelect from "react-select";
import { phone } from "phone";
import { updateCart } from "../../data/api";
import { setCartData } from "../../store/Cart/actions";
import { getLocal, LOCAL_STORAGE_KEYS, setLocal } from "../../data/localStorageHelpers";
import { useSpecificBFPayment } from "../../hooks/useSpecificBFPayment";
var useTypedSelector = useSelector;
var gatewaysWithCustomInputs = [
    Constants.Gateways.GATEWAY_STRIPE,
    Constants.Gateways.GATEWAY_SQUARE,
    Constants.Gateways.GATEWAY_SQUARE_SANDBOX,
];
var PREVIOUS = "Previous Transaction";
var squarePaymentTypes = {
    card: "Card",
    ach: "Pay with Bank Transfer",
    giftCard: "Gift Card",
    cashApp: "Cash App",
    invoice: "Square Invoice",
};
export var setWalletConfirmationPayload = function (walletConfirmationPayload, placeOrder, formikContext, eventData, localization, thirdPartyCustomerId) {
    var _a, _b;
    if (formikContext) {
        var parsedPhone = walletConfirmationPayload.phone;
        var res = phone(walletConfirmationPayload.phone, walletConfirmationPayload.address.country.length === 2
            ? { country: walletConfirmationPayload.address.country, validateMobilePrefix: false }
            : { validateMobilePrefix: false });
        if (res.isValid) {
            parsedPhone = res.phoneNumber;
        }
        else {
            var countryRes = phone(walletConfirmationPayload.phone, {
                country: eventData.clientCountry,
                validateMobilePrefix: false,
            });
            if (countryRes.isValid) {
                parsedPhone = countryRes.phoneNumber;
            }
        }
        var parsedCountryCode_1 = walletConfirmationPayload.address.country;
        if (parsedCountryCode_1.length !== 2 && localization) {
            var locale = localization.countryList.find(function (l) { return l.name.toLowerCase() === parsedCountryCode_1.toLowerCase(); });
            if (locale) {
                parsedCountryCode_1 = locale.code;
            }
        }
        var values = __assign(__assign({ firstName: walletConfirmationPayload.firstName, lastName: walletConfirmationPayload.lastName }, walletConfirmationPayload.address), { phone: parsedPhone, country: parsedCountryCode_1, region: walletConfirmationPayload.address.region && walletConfirmationPayload.address.region.length > 0
                ? walletConfirmationPayload.address.region
                : "N/A", email: walletConfirmationPayload.email, routingNumber: "", accountNumber: "", checkPONumber: "", password: "", confirmPassword: "" });
        var payload = __assign(__assign({}, values), { thirdPartyCustomerId: thirdPartyCustomerId, paymentNumberForStorage: "", tokenInfo: walletConfirmationPayload.tokenInfo, cardCsc: "", cardNumber: "", cardMonth: null, cardYear: null, 
            //paidInFull: false,
            paymentMethodId: walletConfirmationPayload.paymentMethodId, referenceOrderId: null, password: (_a = values.password) !== null && _a !== void 0 ? _a : "", confirmPassword: (_b = values.confirmPassword) !== null && _b !== void 0 ? _b : "", isInvoice: false });
        placeOrder(values, payload, formikContext, formikContext.status.setGlobalError);
    }
};
var PaymentForm = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var placeOrder = _a.placeOrder, widgetPaymentRequest = _a.widgetPaymentRequest, eventData = _a.eventData, path = _a.path, initialValues = _a.initialValues, activePath = _a.activePath, showPrefilledMessage = _a.showPrefilledMessage, setShowPrefilledMessage = _a.setShowPrefilledMessage, iframeSrc = _a.iframeSrc, setIframeSrc = _a.setIframeSrc, showIframeSrc = _a.showIframeSrc, setShowIframeSrc = _a.setShowIframeSrc, boltToken = _a.boltToken, setBoltToken = _a.setBoltToken, isMobile = _a.isMobile, _m = _a.enableSignup, enableSignup = _m === void 0 ? false : _m;
    var paymentMethods = widgetPaymentRequest.paymentMethods, paymentProfile = widgetPaymentRequest.paymentProfile, currency = widgetPaymentRequest.currency;
    var _o = __read(useState(null), 2), paymentMethodId = _o[0], setPaymentMethodId = _o[1];
    var _p = __read(useState(null), 2), squarePayments = _p[0], setSquarePayments = _p[1];
    var _q = __read(useState(null), 2), squareCard = _q[0], setSquareCard = _q[1];
    var _r = __read(useState(), 2), paymentType = _r[0], setPaymentType = _r[1];
    var _s = __read(useState(false), 2), stripeCardReady = _s[0], setStripeCardReady = _s[1];
    var _t = __read(useState(getDefaultCountry(eventData)), 2), defaultCountry = _t[0], setDefaultCountry = _t[1];
    var _u = __read(useState(), 2), cashAppPay = _u[0], setCashAppPay = _u[1];
    var _v = __read(useState(), 2), ach = _v[0], setAch = _v[1];
    var _w = __read(useState(), 2), giftCard = _w[0], setGiftCard = _w[1];
    var _x = __read(useState(), 2), squareCardReady = _x[0], setSquareCardReady = _x[1];
    var _y = __read(useState(), 2), squareACHReady = _y[0], setSquareACHReady = _y[1];
    var _z = __read(useState(), 2), squareGiftCardReady = _z[0], setSquareGiftCardReady = _z[1];
    var _0 = __read(useState(), 2), squareCashAppReady = _0[0], setSquareCashAppReady = _0[1];
    var _1 = __read(useState(false), 2), hideCashAppButton = _1[0], setHideCashAppButton = _1[1];
    var generatePaymentRequest = function (payments, widgetPaymentRequest) { return __awaiter(void 0, void 0, void 0, function () {
        var paymentRequestOptions, paymentRequest;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            paymentRequestOptions = {
                countryCode: widgetPaymentRequest.currency.toUpperCase() === "USD" ? "US" : widgetPaymentRequest.country,
                currencyCode: widgetPaymentRequest.currency.toUpperCase(),
                lineItems: widgetPaymentRequest.lineItems.map(function (lineItem) { return ({
                    amount: lineItem.amount.toFixed(2),
                    label: lineItem.label,
                    pending: false,
                }); }),
                requestBillingContact: true,
                requestShippingContact: true,
                total: {
                    amount: widgetPaymentRequest.total.toFixed(2),
                    label: (_b = (_a = widgetPaymentRequest.paymentProfile) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : "Total",
                    pending: false,
                },
            };
            paymentRequest = payments.paymentRequest(paymentRequestOptions);
            paymentRequest.addEventListener("shippingoptionchanged", function (option) { return __awaiter(void 0, void 0, void 0, function () {
                var data;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            if (!widgetPaymentRequest.cartId) return [3 /*break*/, 2];
                            return [4 /*yield*/, updateCart(widgetPaymentRequest.cartId, { shippingId: option.id }, (_a = eventData === null || eventData === void 0 ? void 0 : eventData.eventNumber.toString()) !== null && _a !== void 0 ? _a : "")];
                        case 1:
                            data = (_d.sent()).data;
                            if (data) {
                                dispatch(setCartData(data));
                                return [2 /*return*/, {
                                        total: {
                                            label: (_c = (_b = widgetPaymentRequest.paymentProfile) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : "Total",
                                            amount: data.total.toFixed(2),
                                            pending: false,
                                        },
                                    }];
                            }
                            else {
                                return [2 /*return*/, {}];
                            }
                            return [3 /*break*/, 3];
                        case 2: return [2 /*return*/, {}];
                        case 3: return [2 /*return*/];
                    }
                });
            }); });
            payments
                .cashAppPay(paymentRequest, {
                redirectURL: window.location.href,
            })
                .then(function (newCashApp) {
                setCashAppPay(newCashApp);
                if (!cashAppPay) {
                    setTimeout(function () {
                        newCashApp.attach("#cashapp-button", {
                            shape: "semiround",
                            width: "full",
                            size: "small",
                        });
                    }, 100);
                    newCashApp.addEventListener("ontokenization", function (event) {
                        var _a;
                        setHideCashAppButton(true);
                        var values = getValuesFromRedirect();
                        submitOrderWithTokenInfo(values, 
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        //@ts-ignore
                        event.detail.tokenResult, Constants.PaymentMethods.PAYMENTMETHOD_SQUARE, placeOrder, formikContext, (_a = externalAccount === null || externalAccount === void 0 ? void 0 : externalAccount.thirdPartyCustomerId) !== null && _a !== void 0 ? _a : "");
                    });
                    newCashApp.addEventListener("customerDismissed", function () {
                        formikContext === null || formikContext === void 0 ? void 0 : formikContext.setSubmitting(false);
                    });
                }
            })
                .catch(function (err) {
                console.log("Payment Method Error (Cash App)", err);
                //eslint-disable-next-line @typescript-eslint/ban-ts-comment
                //@ts-ignore
                if (window.brushfireDebugMode) {
                    log("Cash App unavailable on this device at this time.", Style.base);
                }
            })
                .finally(function () {
                setSquareCashAppReady(true);
            });
            payments
                .ach({
                redirectURI: window.location.href,
                transactionId: (_c = widgetPaymentRequest.cartId) !== null && _c !== void 0 ? _c : "none",
            })
                .then(function (newAch) {
                if (!ach) {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    //@ts-ignore
                    newAch.addEventListener("ontokenization", function (event) {
                        var _a;
                        var values = getValuesFromRedirect();
                        submitOrderWithTokenInfo(values, event.detail.tokenResult, Constants.PaymentMethods.PAYMENTMETHOD_SQUARE, placeOrder, formikContext, (_a = externalAccount === null || externalAccount === void 0 ? void 0 : externalAccount.thirdPartyCustomerId) !== null && _a !== void 0 ? _a : "");
                    });
                }
                setAch(newAch);
            })
                .catch(function (err) {
                console.log("Payment Method Error (ACH Bank Transfer)", err);
                //eslint-disable-next-line @typescript-eslint/ban-ts-comment
                //@ts-ignore
                if (window.brushfireDebugMode) {
                    log("ACH unavailable on this device at this time.", Style.base);
                }
            })
                .finally(function () {
                setSquareACHReady(true);
            });
            payments
                .giftCard(giftCardTheme)
                .then(function (newGiftCard) { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    setTimeout(function () {
                        try {
                            newGiftCard === null || newGiftCard === void 0 ? void 0 : newGiftCard.attach("#square-gift-card");
                        }
                        catch (err) {
                            console.log("Payment Method Error (Gift Card)", err);
                        }
                    }, 100);
                    setGiftCard(newGiftCard);
                    return [2 /*return*/];
                });
            }); })
                .catch(function (err) {
                console.log("Payment Method Error (Gift Card)", err);
                //eslint-disable-next-line @typescript-eslint/ban-ts-comment
                //@ts-ignore
                if (window.brushfireDebugMode) {
                    log("Gift Card unavailable on this device at this time.", Style.base);
                }
            })
                .finally(function () {
                setSquareGiftCardReady(true);
            });
            return [2 /*return*/];
        });
    }); };
    var _2 = useTypedSelector(function (store) { return store.utilities; }), localization = _2.localization, dotNetConstants = _2.constants;
    var kioskEnabled = useTypedSelector(function (store) { var _a; return (_a = store.utilities.kiosk) === null || _a === void 0 ? void 0 : _a.enabled; });
    var _3 = useTypedSelector(function (store) { return store.accounts; }), customerAccount = _3.customerAccount, account = _3.account;
    var inlineErrors = useTypedSelector(function (store) { return store.app.inlineErrors; });
    var dispatch = useDispatch();
    var stripe = useStripe();
    var stripeElements = useElements();
    var intl = useIntl();
    var tryToMountSquare = function (applicationId, locationId, times) {
        if (window === null || window === void 0 ? void 0 : window.Square) {
            if (!squarePayments) {
                setSquarePayments(window.Square.payments(applicationId, locationId));
            }
        }
        else {
            if (times < 10) {
                setTimeout(function () {
                    tryToMountSquare(applicationId, locationId, times + 1);
                }, 1000);
            }
            else {
                dispatch(setInlineError({
                    paymentGatewayOutage: "Payments appear to be unavailable right now. The payment provider is not responding. Please try again later.",
                }));
            }
        }
    };
    useEffect(function () {
        var _a, _b;
        var applicationId = (paymentProfile === null || paymentProfile === void 0 ? void 0 : paymentProfile.gatewayId) === Constants.Gateways.GATEWAY_SQUARE
            ? dotNetConstants === null || dotNetConstants === void 0 ? void 0 : dotNetConstants.squareApplicationId
            : dotNetConstants === null || dotNetConstants === void 0 ? void 0 : dotNetConstants.squareSandboxApplicationId;
        var locationId = (_b = (_a = paymentProfile === null || paymentProfile === void 0 ? void 0 : paymentProfile.config) === null || _a === void 0 ? void 0 : _a.locationId) !== null && _b !== void 0 ? _b : "";
        if (applicationId && locationId) {
            tryToMountSquare(applicationId, locationId, 0);
        }
    }, [dotNetConstants, paymentProfile]);
    useEffect(function () {
        var checkStripe = function () {
            if (!stripe && (paymentProfile === null || paymentProfile === void 0 ? void 0 : paymentProfile.gatewayId) === Constants.Gateways.GATEWAY_STRIPE) {
                dispatch(setInlineError({
                    paymentGatewayOutage: "Payments appear to be unavailable right now. The payment provider is not responding. Please try again later.",
                }));
            }
        };
        var timeout = setTimeout(checkStripe, 10000);
        return function () { return clearTimeout(timeout); };
    }, [stripe]);
    var _4 = useContext(WidgetContext), externalAccount = _4.externalAccount, isPortal = _4.isPortal, darkMode = _4.darkMode;
    var formikContext = useContext(AppFormContext).formikContext;
    var freeCheckout = widgetPaymentRequest.total === 0;
    var eCheck = paymentMethods === null || paymentMethods === void 0 ? void 0 : paymentMethods.find(function (p) { return p.paymentMethodId === Constants.PaymentMethods.PAYMENTMETHOD_ECHECK; });
    var showCheckPO = !!(paymentMethods === null || paymentMethods === void 0 ? void 0 : paymentMethods.find(function (p) { return p.infoGrouping === "CheckPO" && p.name === paymentType; }));
    var _5 = useSpecificBFPayment(widgetPaymentRequest.paymentMethods), paymentSourceTypes = _5.paymentSourceTypes, customPaymentMethodIds = _5.customPaymentMethodIds, bfPaymentInvalid = _5.bfPaymentInvalid;
    var paymentGroups = [];
    if (!bfPaymentInvalid && widgetPaymentRequest.total > 0) {
        // This takes care of if payment is a Guid
        if (customPaymentMethodIds.length > 0) {
            customPaymentMethodIds.forEach(function (id) {
                var customPaymentMethod = paymentMethods.find(function (method) { return method.paymentMethodId.toLowerCase() === id.toLowerCase(); });
                if ((customPaymentMethod === null || customPaymentMethod === void 0 ? void 0 : customPaymentMethod.infoGrouping) !== "None" && (customPaymentMethod === null || customPaymentMethod === void 0 ? void 0 : customPaymentMethod.infoGrouping) !== "CheckPO") {
                    if ((customPaymentMethod === null || customPaymentMethod === void 0 ? void 0 : customPaymentMethod.infoGrouping) &&
                        !paymentGroups.includes(customPaymentMethod.infoGrouping) &&
                        !((customPaymentMethod === null || customPaymentMethod === void 0 ? void 0 : customPaymentMethod.infoGrouping) === "Card" && widgetPaymentRequest.total < 0)) {
                        paymentGroups.push(customPaymentMethod === null || customPaymentMethod === void 0 ? void 0 : customPaymentMethod.infoGrouping);
                    }
                }
                else {
                    if (!paymentGroups.includes(customPaymentMethod === null || customPaymentMethod === void 0 ? void 0 : customPaymentMethod.name)) {
                        paymentGroups.push(customPaymentMethod === null || customPaymentMethod === void 0 ? void 0 : customPaymentMethod.name);
                    }
                }
            });
        }
        if (paymentSourceTypes.includes(PaymentSourceTypes.CARD)) {
            paymentGroups.push(squarePaymentTypes.card);
        }
        if (paymentSourceTypes.includes(PaymentSourceTypes.GIFT_CARD)) {
            paymentGroups.push(squarePaymentTypes.giftCard);
        }
        if (paymentSourceTypes.includes(PaymentSourceTypes.INVOICE)) {
            paymentGroups.push(squarePaymentTypes.invoice);
        }
        if (paymentSourceTypes.includes(PaymentSourceTypes.BANK_ACCOUNT)) {
            paymentGroups.push(squarePaymentTypes.ach);
        }
        if (paymentSourceTypes.includes(PaymentSourceTypes.CASH_APP)) {
            paymentGroups.push(squarePaymentTypes.cashApp);
        }
    }
    else {
        if (Object.keys(widgetPaymentRequest.referenceOrders).length > 0) {
            paymentGroups.push(PREVIOUS);
        }
        else {
            if ((_b = paymentProfile === null || paymentProfile === void 0 ? void 0 : paymentProfile.config) === null || _b === void 0 ? void 0 : _b.allowCards) {
                paymentGroups.push(squarePaymentTypes.card);
            }
            if (((_c = paymentProfile === null || paymentProfile === void 0 ? void 0 : paymentProfile.config) === null || _c === void 0 ? void 0 : _c.allowGiftCards) && giftCard) {
                paymentGroups.push(squarePaymentTypes.giftCard);
            }
            if (((_e = (_d = paymentProfile === null || paymentProfile === void 0 ? void 0 : paymentProfile.config) === null || _d === void 0 ? void 0 : _d.invoice) === null || _e === void 0 ? void 0 : _e.allowInternet) && widgetPaymentRequest.total > 0) {
                paymentGroups.push(squarePaymentTypes.invoice);
            }
            if (((_f = paymentProfile === null || paymentProfile === void 0 ? void 0 : paymentProfile.config) === null || _f === void 0 ? void 0 : _f.allowAch) && ach) {
                paymentGroups.push(squarePaymentTypes.ach);
            }
            if (((_g = paymentProfile === null || paymentProfile === void 0 ? void 0 : paymentProfile.config) === null || _g === void 0 ? void 0 : _g.allowCashApp) && cashAppPay) {
                paymentGroups.push(squarePaymentTypes.cashApp);
            }
            paymentMethods === null || paymentMethods === void 0 ? void 0 : paymentMethods.forEach(function (p) {
                var _a;
                if (p.infoGrouping === "Card" && ((_a = paymentProfile === null || paymentProfile === void 0 ? void 0 : paymentProfile.config) === null || _a === void 0 ? void 0 : _a.allowCards) === false) {
                    //skip it
                }
                else if (p.infoGrouping !== "None" && p.infoGrouping !== "CheckPO") {
                    if (!paymentGroups.includes(p.infoGrouping) &&
                        !(p.infoGrouping === "Card" && widgetPaymentRequest.total < 0)) {
                        paymentGroups.push(p.infoGrouping);
                    }
                }
                else {
                    if (!paymentGroups.includes(p.name)) {
                        paymentGroups.push(p.name);
                    }
                }
            });
        }
    }
    var saveValuesForRedirect = function (values) {
        setLocal(LOCAL_STORAGE_KEYS.REDIRECT_VALUES, JSON.stringify(values), 60 * 60);
    };
    var getValuesFromRedirect = function () {
        var _a;
        return JSON.parse((_a = getLocal(LOCAL_STORAGE_KEYS.REDIRECT_VALUES)) !== null && _a !== void 0 ? _a : "{}");
    };
    var submitOrderWithTokenInfo = function (values, tokenResult, paymentMethodId, placeOrder, formikContext, thirdPartyCustomerId) {
        var _a, _b, _c, _d, _e;
        if (thirdPartyCustomerId === void 0) { thirdPartyCustomerId = ""; }
        if ((tokenResult === null || tokenResult === void 0 ? void 0 : tokenResult.status) === "OK" && !!(tokenResult === null || tokenResult === void 0 ? void 0 : tokenResult.token)) {
            var payload = __assign(__assign({}, values), { thirdPartyCustomerId: thirdPartyCustomerId, paymentNumberForStorage: "", tokenInfo: { token: tokenResult.token, method: (_b = (_a = tokenResult.details) === null || _a === void 0 ? void 0 : _a.method) !== null && _b !== void 0 ? _b : "" }, cardCsc: "", cardNumber: "", cardMonth: null, cardYear: null, paymentMethodId: paymentMethodId, referenceOrderId: null, password: (_c = values.password) !== null && _c !== void 0 ? _c : "", confirmPassword: (_d = values.confirmPassword) !== null && _d !== void 0 ? _d : "", isInvoice: false });
            placeOrder(values, payload, formikContext, formikContext.status.setGlobalError);
        }
        else {
            var errorMessage = "Tokenization failed with status: ".concat((_e = tokenResult === null || tokenResult === void 0 ? void 0 : tokenResult.status) !== null && _e !== void 0 ? _e : "Unknown");
            if (tokenResult === null || tokenResult === void 0 ? void 0 : tokenResult.errors) {
                errorMessage += " and errors: ".concat(JSON.stringify(tokenResult.errors));
            }
            formikContext.status.setGlobalError(errorMessage);
            formikContext.setSubmitting(false);
            setHideCashAppButton(false);
        }
    };
    var giftCardTheme = {
        style: {
            ".input-container": {
                borderColor: darkMode ? "#393e45" : "#e5e6e7",
                borderRadius: "3px",
            },
            ".input-container.is-focus": {
                borderColor: darkMode ? "#f5f5f5" : "#4a525a",
                borderWidth: "1px",
            },
            ".input-container.is-error": {
                borderColor: "#e71d36",
                borderWidth: "2px",
            },
            input: {
                color: darkMode ? "#FFFFFF" : "#24272b",
                backgroundColor: darkMode ? "#2d2f32" : "#ffffff",
                fontSize: Styles.sFontSize,
            },
            "input::placeholder": {
                color: darkMode ? "rgba(255, 255, 255, 0.34)" : "rgba(36, 39, 43, 0.29)",
            },
            "input.is-error": {
                color: "#e71d36",
            },
            ".message-text": {
                color: darkMode ? "#FFFFFF" : "#24272b",
            },
            ".message-text.is-error": {
                color: Styles.error,
            },
            ".message-icon": {
                color: darkMode ? "#FFFFFF" : "#24272b",
            },
            ".message-icon.is-error": {
                color: "#e71d36",
            },
        },
    };
    var setGiftCardTheme = function (giftCard) {
        giftCard.configure(giftCardTheme);
    };
    useEffect(function () {
        if (giftCard) {
            setGiftCardTheme(giftCard);
        }
    }, [darkMode, giftCard]);
    useEffect(function () {
        if (squarePayments) {
            setTimeout(function () {
                generatePaymentRequest(squarePayments, widgetPaymentRequest);
            }, 100);
        }
    }, [squarePayments]);
    var setCheckoutError = function (errorMessage) {
        dispatch(setInlineError({ checkoutForm: errorMessage }));
    };
    useEffect(function () {
        var _a, _b;
        if ((paymentProfile === null || paymentProfile === void 0 ? void 0 : paymentProfile.gatewayId) === Constants.Gateways.GATEWAY_SQUARE &&
            ((_a = paymentProfile === null || paymentProfile === void 0 ? void 0 : paymentProfile.config) === null || _a === void 0 ? void 0 : _a.status) !== (dotNetConstants === null || dotNetConstants === void 0 ? void 0 : dotNetConstants.squareStatuses.connected) &&
            ((_b = paymentProfile === null || paymentProfile === void 0 ? void 0 : paymentProfile.config) === null || _b === void 0 ? void 0 : _b.status) !== (dotNetConstants === null || dotNetConstants === void 0 ? void 0 : dotNetConstants.squareStatuses.locationActive)) {
            setCheckoutError("Payments are currently unavailable for this event because the payment processor connection is either disconnected or inactive.");
        }
    }, [paymentProfile]);
    useEffect(function () {
        var _a;
        if (((_a = paymentGroups === null || paymentGroups === void 0 ? void 0 : paymentGroups.length) !== null && _a !== void 0 ? _a : 0) > 0) {
            if (widgetPaymentRequest.total < 0 && Object.keys(widgetPaymentRequest.referenceOrders).length > 0) {
                setPaymentType(PREVIOUS);
            }
            else {
                setPaymentType(!!(paymentGroups === null || paymentGroups === void 0 ? void 0 : paymentGroups.includes("Card")) ? "Card" : paymentGroups[0]);
            }
        }
    }, [paymentGroups.length]);
    useEffect(function () {
        var handleIframe = function (event) {
            var _a, _b;
            if ((_b = (_a = formikContext === null || formikContext === void 0 ? void 0 : formikContext.status) === null || _a === void 0 ? void 0 : _a.bag) === null || _b === void 0 ? void 0 : _b.isCheckout) {
                if (event.data === "success") {
                    setIframeSrc(undefined);
                    setTimeout(function () {
                        formikContext === null || formikContext === void 0 ? void 0 : formikContext.submitForm();
                    }, 1000);
                }
                else if (event.data === "cancel") {
                    setCheckoutError("Payment Cancelled");
                    formikContext.setSubmitting(false);
                    dispatch(setFormIsSubmitting(false));
                    setIframeSrc(undefined);
                }
            }
        };
        window.addEventListener("message", handleIframe);
        return function () {
            window.removeEventListener("message", handleIframe);
        };
    }, [(_j = (_h = formikContext === null || formikContext === void 0 ? void 0 : formikContext.status) === null || _h === void 0 ? void 0 : _h.bag) === null || _j === void 0 ? void 0 : _j.isCheckout]);
    useEffect(function () {
        if (iframeSrc) {
            setTimeout(function () {
                setShowIframeSrc(true);
                setTimeout(function () {
                    var frame = document.getElementById("js-payment-confirm");
                    if (frame) {
                        frame.onload = function () {
                            var _a;
                            (_a = frame.contentWindow) === null || _a === void 0 ? void 0 : _a.postMessage("ping", "*");
                        };
                    }
                }, 150);
            }, 500);
        }
    }, [iframeSrc]);
    var validationShape = {
        firstName: Yup.string()
            .typeError("First Name is required")
            .required("First Name is required")
            .max(50, "First Name must be 50 or fewer characters"),
        lastName: Yup.string()
            .typeError("Last Name is required")
            .required("Last Name is required")
            .max(50, "Last Name must be 50 or fewer characters"),
        email: Yup.string()
            .typeError("Email is required")
            .email("Email is invalid")
            .required("Email is required")
            .max(100, "Email must be 100 or fewer characters"),
        phone: Yup.string()
            .typeError("Phone is required")
            .test("valid", "Phone number is invalid", function (val) { return !!val && isPossiblePhoneNumber(val); })
            .required("Phone is required")
            .max(20, "Phone is too long"),
        street1: Yup.string()
            .typeError("Address is required")
            .required("Address is required")
            .max(100, "Address must be 100 or fewer characters"),
        street2: Yup.string()
            .nullable()
            .max(100, "Address 2 must be 100 or fewer characters"),
        region: Yup.string()
            .typeError("Region is required")
            .required("Region is required")
            .max(100, "Region must be 100 or fewer characters"),
        city: Yup.string()
            .typeError("City is required")
            .required("City is required")
            .max(100, "City must be 100 or fewer characters"),
        country: Yup.string()
            .typeError("Country is required")
            .required("Country is required")
            .max(2, "Country must be 2 or fewer characters"),
        postalCode: Yup.string()
            .max(10, "Postal Code must be 10 or fewer characters")
            .typeError("Postal Code is required")
            .required("Postal Code is required"),
        password: Yup.string()
            .nullable()
            .test("len", "Password must be at least 8 characters", function (val) {
            return val === null || val === undefined || (val === null || val === void 0 ? void 0 : val.length) === 0 || ((val === null || val === void 0 ? void 0 : val.length) >= 8 && (val === null || val === void 0 ? void 0 : val.length) <= 500);
        }),
        confirmPassword: Yup.string()
            .nullable()
            .oneOf([Yup.ref("password")], "Passwords Must Match"),
    };
    if (!gatewaysWithCustomInputs.includes((_k = paymentProfile === null || paymentProfile === void 0 ? void 0 : paymentProfile.gatewayId) !== null && _k !== void 0 ? _k : "") && paymentType === "Card") {
        validationShape.card = Yup.string().required("Card Number is required");
        validationShape.exp = Yup.string()
            .typeError("Card CVV is required")
            .test("future", "Cannot use expired card", function (val) {
            var now = new Date();
            var _a = __read((val || "").split("/"), 2), expStrMonth = _a[0], expStrYear = _a[1];
            var expMonth = parseInt(expStrMonth);
            var expYear = parseInt("20".concat(expStrYear));
            var month = now.getMonth() + 1;
            var year = now.getFullYear();
            return expYear > year || (expYear === year && expMonth >= month);
        })
            .required("Card Expiration is required");
        validationShape.cvv = Yup.string()
            .typeError("Card CVV is required")
            .min(0)
            .max(9999)
            .required("Card CVV is required");
    }
    if (!gatewaysWithCustomInputs.includes((_l = paymentProfile === null || paymentProfile === void 0 ? void 0 : paymentProfile.gatewayId) !== null && _l !== void 0 ? _l : "") && paymentType === (eCheck === null || eCheck === void 0 ? void 0 : eCheck.infoGrouping)) {
        validationShape.routingNumber = Yup.string().required("Routing Number is required");
        validationShape.accountNumber = Yup.string().required("Account Number is required");
    }
    if (paymentType === PREVIOUS) {
        validationShape.referenceOrderId = Yup.string().required("Previous transaction is required");
    }
    var formSchema = Yup.object().shape(validationShape);
    var submitOrder = function (values, formikBag, setGlobalError) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            formikBag.setSubmitting(true);
            formSchema
                .validate(values, { strict: true, abortEarly: false })
                .then(function () {
                processOrder(values, formikBag, setGlobalError, true);
            })
                .catch(function (err) {
                var errors = {};
                if ((err === null || err === void 0 ? void 0 : err.inner) && Array.isArray(err.inner)) {
                    err.inner.forEach(function (error) {
                        errors[error.path] = error.message;
                    });
                }
                formikBag.setErrors(errors);
                formikBag.setSubmitting(false);
            });
            return [2 /*return*/];
        });
    }); };
    var setWalletConfirmationPayloadLocal = function (walletConfirmationPayload) {
        var _a;
        if (formikContext) {
            setWalletConfirmationPayload(walletConfirmationPayload, placeOrder, formikContext, eventData, localization, (_a = externalAccount === null || externalAccount === void 0 ? void 0 : externalAccount.thirdPartyCustomerId) !== null && _a !== void 0 ? _a : "");
        }
    };
    var processOrder = function (values, formikBag, setGlobalError, shouldSubmit) { return __awaiter(void 0, void 0, void 0, function () {
        var tokenInfo, submit, cleanUpSubmit, isCard, isCheck, isPreviousPayment, isInvoice, cardElement, _a, error, paymentMethod, err_1, squareToken, addressLines, squareResults, err_2, authData, cardData_1, bankData, amount, ex, errorMessage, payload;
        var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3;
        return __generator(this, function (_4) {
            switch (_4.label) {
                case 0:
                    tokenInfo = {};
                    submit = shouldSubmit;
                    cleanUpSubmit = true;
                    isCard = paymentType === "Card";
                    isCheck = paymentType === "ECheck";
                    isPreviousPayment = paymentType === PREVIOUS;
                    isInvoice = paymentType === "Square Invoice";
                    if (!(isCard || isCheck)) return [3 /*break*/, 15];
                    if (!(stripe && stripeElements)) return [3 /*break*/, 5];
                    cardElement = stripeElements.getElement(CardElement);
                    if (!cardElement) return [3 /*break*/, 4];
                    _4.label = 1;
                case 1:
                    _4.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, stripe.createPaymentMethod({
                            type: "card",
                            card: cardElement,
                            billing_details: {
                                email: values.email,
                                name: "".concat(values.firstName, " ").concat(values.lastName),
                                phone: values.phone,
                                address: {
                                    city: values.city,
                                    country: values.country,
                                    line1: values.street1,
                                    line2: values.street2,
                                    postal_code: values.postalCode,
                                    state: values.region,
                                },
                            },
                        })];
                case 2:
                    _a = _4.sent(), error = _a.error, paymentMethod = _a.paymentMethod;
                    if (error) {
                        submit = false;
                        dispatch(setInlineError({
                            stripePaymentError: (_b = error === null || error === void 0 ? void 0 : error.message) !== null && _b !== void 0 ? _b : "Something went wrong while verifying your payment information. Please try again or use a different payment method.",
                        }));
                    }
                    else if (paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.id) {
                        tokenInfo.paymentMethodId = paymentMethod.id;
                    }
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _4.sent();
                    formikBag.setSubmitting(false);
                    return [3 /*break*/, 4];
                case 4: return [3 /*break*/, 14];
                case 5:
                    if (!squareCard) return [3 /*break*/, 13];
                    return [4 /*yield*/, squareCard.tokenize()];
                case 6:
                    squareToken = _4.sent();
                    if (!squareToken.token) return [3 /*break*/, 11];
                    tokenInfo.token = squareToken.token;
                    tokenInfo.method = (_d = (_c = squareToken.details) === null || _c === void 0 ? void 0 : _c.method) !== null && _d !== void 0 ? _d : "";
                    if (!squarePayments) return [3 /*break*/, 10];
                    addressLines = [values.street1];
                    if (values.street2) {
                        addressLines.push(values.street2);
                    }
                    _4.label = 7;
                case 7:
                    _4.trys.push([7, 9, , 10]);
                    return [4 /*yield*/, squarePayments.verifyBuyer(squareToken.token, {
                            amount: widgetPaymentRequest.total.toFixed(2),
                            billingContact: {
                                addressLines: addressLines,
                                city: values.city,
                                countryCode: values.country,
                                familyName: values.lastName,
                                givenName: values.firstName,
                                postalCode: values.postalCode,
                                state: values.region,
                            },
                            currencyCode: (_f = (_e = paymentProfile === null || paymentProfile === void 0 ? void 0 : paymentProfile.config) === null || _e === void 0 ? void 0 : _e.currency) !== null && _f !== void 0 ? _f : "USD",
                            intent: "CHARGE",
                        })];
                case 8:
                    squareResults = _4.sent();
                    if (squareResults === null || squareResults === void 0 ? void 0 : squareResults.token) {
                        tokenInfo.token = squareToken.token;
                        tokenInfo.buyerVerificationToken = squareResults === null || squareResults === void 0 ? void 0 : squareResults.token;
                    }
                    else {
                        submit = false;
                        dispatch(setInlineError({
                            squarePaymentError: "Something went wrong while verifying your payment information. Please try again or use a different payment method.",
                        }));
                    }
                    return [3 /*break*/, 10];
                case 9:
                    err_2 = _4.sent();
                    formikBag.setSubmitting(false);
                    return [3 /*break*/, 10];
                case 10: return [3 /*break*/, 12];
                case 11:
                    submit = false;
                    dispatch(setInlineError({
                        squarePaymentError: (_h = (_g = squareToken.errors) === null || _g === void 0 ? void 0 : _g.map(function (err) { return err.message; }).join(". ")) !== null && _h !== void 0 ? _h : "Something went wrong while verifying your payment information. Please try again or use a different payment method.",
                    }));
                    _4.label = 12;
                case 12: return [3 /*break*/, 14];
                case 13:
                    if ((paymentProfile === null || paymentProfile === void 0 ? void 0 : paymentProfile.gatewayId) === Constants.Gateways.GATEWAY_AUTHORIZENET) {
                        submit = false;
                        try {
                            authData = {
                                clientKey: paymentProfile === null || paymentProfile === void 0 ? void 0 : paymentProfile.options.publicClientKey,
                                apiLoginID: paymentProfile === null || paymentProfile === void 0 ? void 0 : paymentProfile.options.apiLoginId,
                            };
                            cardData_1 = isCard && values.card && values.cvv && values.exp
                                ? {
                                    cardNumber: (_j = values.card) === null || _j === void 0 ? void 0 : _j.toString().replaceAll(" ", ""),
                                    month: (_l = (_k = values.exp) === null || _k === void 0 ? void 0 : _k.split("/")[0]) !== null && _l !== void 0 ? _l : "",
                                    year: (_o = (_m = values.exp) === null || _m === void 0 ? void 0 : _m.split("/")[1]) !== null && _o !== void 0 ? _o : "",
                                    cardCode: values.cvv.toString(),
                                    zip: values.postalCode,
                                    fullName: "".concat(values.firstName, " ").concat(values.lastName),
                                }
                                : undefined;
                            bankData = isCheck && values.accountNumber && values.routingNumber
                                ? {
                                    routingNumber: values.routingNumber
                                        .toString()
                                        .replaceAll(" ", "")
                                        .replaceAll("-", ""),
                                    accountNumber: values.accountNumber.toString(),
                                    nameOnAccount: "".concat(values.firstName, " ").concat(values.lastName),
                                    accountType: "checking",
                                }
                                : undefined;
                            window.Accept.dispatchData({
                                authData: authData,
                                cardData: cardData_1,
                                bankData: bankData,
                            }, function (response) {
                                var _a, _b, _c, _d, _e, _f;
                                if (response.messages.resultCode === "Error") {
                                    if (shouldSubmit) {
                                        setCheckoutError((_c = (_b = (_a = response.messages) === null || _a === void 0 ? void 0 : _a.message) === null || _b === void 0 ? void 0 : _b.map(function (m) { return m.text; }).join(". ")) !== null && _c !== void 0 ? _c : "An error occured while attempting to make your payment.");
                                        formikBag.setSubmitting(false);
                                    }
                                    else {
                                        formikBag.setSubmitting(false);
                                    }
                                }
                                else {
                                    var payload = __assign(__assign({}, values), { thirdPartyCustomerId: (_d = externalAccount === null || externalAccount === void 0 ? void 0 : externalAccount.thirdPartyCustomerId) !== null && _d !== void 0 ? _d : "", paymentNumberForStorage: "", tokenInfo: response.opaqueData, cardCsc: "", cardNumber: cardData_1 ? cardData_1.cardNumber.slice(-4) : "", cardMonth: cardData_1 ? parseInt(cardData_1.month) : null, cardYear: cardData_1 ? parseInt(cardData_1.year) : null, routingNumber: "", accountNumber: "", paymentMethodId: isCheck
                                            ? Constants.PaymentMethods.PAYMENTMETHOD_ECHECK
                                            : paymentMethodId, referenceOrderId: null, password: (_e = values.password) !== null && _e !== void 0 ? _e : "", confirmPassword: (_f = values.confirmPassword) !== null && _f !== void 0 ? _f : "", isInvoice: false });
                                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                    //@ts-ignore
                                    delete payload.card;
                                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                    //@ts-ignore
                                    delete payload.cvv;
                                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                    //@ts-ignore
                                    delete payload.exp;
                                    if (values.phone === "") {
                                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                        //@ts-ignore
                                        payload.phone = null;
                                    }
                                    placeOrder(values, payload, formikBag, setGlobalError);
                                }
                            });
                        }
                        catch (err) {
                            formikBag.setSubmitting(false);
                        }
                    }
                    else if ((paymentProfile === null || paymentProfile === void 0 ? void 0 : paymentProfile.gatewayId) === Constants.Gateways.GATEWAY_BOLT && boltToken) {
                        tokenInfo.token = boltToken;
                        setBoltToken(undefined);
                    }
                    _4.label = 14;
                case 14: return [3 /*break*/, 16];
                case 15:
                    if (isUsingSquare && paymentType === squarePaymentTypes.ach) {
                        submit = false;
                        cleanUpSubmit = false;
                        saveValuesForRedirect(values);
                        amount = {
                            total: Math.round(widgetPaymentRequest.total * 100),
                            currencyCode: widgetPaymentRequest.currency.toUpperCase(),
                        };
                        try {
                            ach === null || ach === void 0 ? void 0 : ach.tokenize({
                                accountHolderName: "".concat(values.firstName, " ").concat(values.lastName),
                                intent: "CHARGE",
                                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                //@ts-ignore
                                amount: amount,
                                total: {
                                    amount: Math.round(widgetPaymentRequest.total * 100),
                                    currencyCode: widgetPaymentRequest.currency.toUpperCase(),
                                },
                            });
                        }
                        catch (e) {
                            ex = e;
                            errorMessage = "Tokenization failed:\n";
                            if (ex === null || ex === void 0 ? void 0 : ex.errors) {
                                errorMessage += ex.errors.map(function (x) { return x.message; }).join("\n");
                            }
                            formikContext === null || formikContext === void 0 ? void 0 : formikContext.status.setGlobalError(errorMessage);
                            formikContext === null || formikContext === void 0 ? void 0 : formikContext.setSubmitting(false);
                        }
                    }
                    else if (isUsingSquare && paymentType === squarePaymentTypes.giftCard && giftCard) {
                        submit = false;
                        giftCard
                            .tokenize()
                            .then(function (result) {
                            var _a;
                            submitOrderWithTokenInfo(values, result, Constants.PaymentMethods.PAYMENTMETHOD_SQUARE, placeOrder, formikContext, (_a = externalAccount === null || externalAccount === void 0 ? void 0 : externalAccount.thirdPartyCustomerId) !== null && _a !== void 0 ? _a : "");
                        })
                            .catch(function (ex) {
                            var errorMessage = "Tokenization failed:\n";
                            if (ex === null || ex === void 0 ? void 0 : ex.errors) {
                                errorMessage += ex.errors.map(function (x) { return x.message; }).join("\n");
                            }
                            formikContext === null || formikContext === void 0 ? void 0 : formikContext.status.setGlobalError(errorMessage);
                            formikContext === null || formikContext === void 0 ? void 0 : formikContext.setSubmitting(false);
                        });
                    }
                    else if (isUsingSquare && paymentType === squarePaymentTypes.cashApp && cashAppPay) {
                        submit = false;
                        cleanUpSubmit = false;
                        //click cash app button
                        saveValuesForRedirect(values);
                        (_p = document.getElementById("cashapp-button")) === null || _p === void 0 ? void 0 : _p.click();
                    }
                    _4.label = 16;
                case 16:
                    if (eventData && submit) {
                        payload = __assign(__assign({}, values), { thirdPartyCustomerId: (_q = externalAccount === null || externalAccount === void 0 ? void 0 : externalAccount.thirdPartyCustomerId) !== null && _q !== void 0 ? _q : "", paymentNumberForStorage: "", referenceOrderId: isPreviousPayment && paymentType === PREVIOUS ? (_r = values.referenceOrderId) !== null && _r !== void 0 ? _r : null : null, tokenInfo: tokenInfo, cardCsc: isCard ? (_t = (_s = values.cvv) === null || _s === void 0 ? void 0 : _s.toString()) !== null && _t !== void 0 ? _t : "" : "", cardNumber: isCard ? (_v = (_u = values.card) === null || _u === void 0 ? void 0 : _u.toString()) !== null && _v !== void 0 ? _v : "" : "", cardMonth: isCard ? parseInt((_x = (_w = values.exp) === null || _w === void 0 ? void 0 : _w.split("/")[0]) !== null && _x !== void 0 ? _x : "0") : null, cardYear: isCard ? parseInt((_z = (_y = values.exp) === null || _y === void 0 ? void 0 : _y.split("/")[1]) !== null && _z !== void 0 ? _z : "0") : null, routingNumber: isCheck ? values.routingNumber.toString() : "", accountNumber: isCheck ? values.accountNumber.toString() : "", 
                            //checkPONumber: showCheckPO ? values.checkPONumber : "",
                            password: (_0 = values.password) !== null && _0 !== void 0 ? _0 : "", confirmPassword: (_1 = values.confirmPassword) !== null && _1 !== void 0 ? _1 : "", paymentMethodId: isCheck
                                ? Constants.PaymentMethods.PAYMENTMETHOD_ECHECK
                                : isInvoice
                                    ? Constants.PaymentMethods.PAYMENTMETHOD_SQUARE
                                    : isCard
                                        ? paymentMethodId
                                        : (_3 = (_2 = paymentMethods === null || paymentMethods === void 0 ? void 0 : paymentMethods.find(function (p) { return p.name === paymentType; })) === null || _2 === void 0 ? void 0 : _2.paymentMethodId) !== null && _3 !== void 0 ? _3 : paymentMethodId, isInvoice: isInvoice });
                        if (values.phone === "") {
                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                            //@ts-ignore
                            payload.phone = null;
                        }
                        placeOrder(values, payload, formikBag, setGlobalError);
                    }
                    else {
                        if ((paymentProfile === null || paymentProfile === void 0 ? void 0 : paymentProfile.gatewayId) !== Constants.Gateways.GATEWAY_AUTHORIZENET && cleanUpSubmit) {
                            formikBag.setSubmitting(false);
                        }
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var receiveCardType = function (cardType) {
        if (cardType) {
            getPaymentMethodId(cardType.replaceAll("-", "")).then(function (paymentMethodId) {
                setPaymentMethodId(paymentMethodId);
            });
        }
        else {
            setPaymentMethodId(null);
        }
    };
    var addressField = {
        id: "",
        label: "Address",
        type: FieldType[FieldType.Address],
        value: "",
        validationExpression: "",
        isRequired: !freeCheckout,
        notes: "",
        hasError: false,
        errorMessage: "",
        isDisabled: false,
        isSensitive: false,
        isIntegration: false,
        isAdmin: false,
        specialFieldId: "",
        parentOptionId: "",
        parentFieldId: null,
        formObjectId: null,
        options: [],
        specialFieldLabel: "",
        childFields: [
            {
                id: "street1",
                label: "Street 1",
                value: "",
                displayOrder: 0,
                specialFieldLabel: "Street1",
            },
            {
                id: "street2",
                label: "Street 2",
                value: "",
                displayOrder: 1,
                specialFieldLabel: "Street2",
            },
            {
                id: "city",
                label: "City",
                value: "",
                displayOrder: 2,
                specialFieldLabel: "City",
            },
            {
                id: "region",
                label: "Region",
                value: "",
                displayOrder: 3,
                specialFieldLabel: "Region",
            },
            {
                id: "postalCode",
                label: "Postal Code",
                value: "",
                displayOrder: 4,
                specialFieldLabel: "PostalCode",
            },
            {
                id: "country",
                label: "Country",
                value: "",
                displayOrder: 5,
                specialFieldLabel: "Country",
            },
        ],
        remoteUrl: "",
        parentOptionIsSelected: false,
        hasRelevantOutput: false,
        confirm: false,
    };
    if (!initialValues) {
        return null;
    }
    var isUsingSquare = (paymentProfile === null || paymentProfile === void 0 ? void 0 : paymentProfile.gatewayId) === Constants.Gateways.GATEWAY_SQUARE ||
        (paymentProfile === null || paymentProfile === void 0 ? void 0 : paymentProfile.gatewayId) === Constants.Gateways.GATEWAY_SQUARE_SANDBOX;
    var squareIsReady = squareACHReady && squareCardReady && squareCashAppReady && squareGiftCardReady;
    var isUsingStripe = (paymentProfile === null || paymentProfile === void 0 ? void 0 : paymentProfile.gatewayId) === Constants.Gateways.GATEWAY_STRIPE;
    var loadingPayments = ((isUsingSquare && !squareIsReady) || (isUsingStripe && !stripeCardReady)) && !!(paymentGroups === null || paymentGroups === void 0 ? void 0 : paymentGroups.includes("Card"));
    var renderPaymentGroup = function (paymentGroup) {
        var _a, _b, _c, _d;
        var content = null;
        switch (paymentGroup) {
            case squarePaymentTypes.card:
                content = (_jsx("div", { children: squarePayments &&
                        dotNetConstants &&
                        ((paymentProfile === null || paymentProfile === void 0 ? void 0 : paymentProfile.gatewayId) === Constants.Gateways.GATEWAY_SQUARE ||
                            (paymentProfile === null || paymentProfile === void 0 ? void 0 : paymentProfile.gatewayId) === Constants.Gateways.GATEWAY_SQUARE_SANDBOX) && (_jsxs(_Fragment, { children: [_jsx(Square, { id: "payment", name: "payment", label: "Card", setPaymentMethodId: setPaymentMethodId, applicationId: (paymentProfile === null || paymentProfile === void 0 ? void 0 : paymentProfile.gatewayId) === Constants.Gateways.GATEWAY_SQUARE
                                    ? dotNetConstants.squareApplicationId
                                    : dotNetConstants.squareSandboxApplicationId, locationId: (_b = (_a = paymentProfile === null || paymentProfile === void 0 ? void 0 : paymentProfile.config) === null || _a === void 0 ? void 0 : _a.locationId) !== null && _b !== void 0 ? _b : "", setSquareCard: setSquareCard, payments: squarePayments, setError: setCheckoutError, setSquareCardReady: setSquareCardReady }), _jsx("div", __assign({ className: "ta-right" }, { children: _jsxs("small", __assign({ className: "mini m-right-sm faded" }, { children: ["Powered By ", _jsx("i", { className: "fa-kit fa-square-logo" }), " Square"] })) }))] })) }));
                break;
            case squarePaymentTypes.giftCard:
                content = (_jsxs("div", { children: [_jsx("div", { id: "square-gift-card" }), _jsx("div", __assign({ className: "ta-right" }, { children: _jsxs("small", __assign({ className: "mini m-right-sm faded" }, { children: ["Powered By ", _jsx("i", { className: "fa-kit fa-square-logo" }), " Square"] })) }))] }));
                break;
            case squarePaymentTypes.invoice:
                content = (_jsxs("div", { children: [_jsx("div", __assign({ className: "checkout-disclaimer" }, { children: _jsxs("small", { children: ["After your order is complete, an invoice will be emailed to the address provided above.", " ", _jsx("b", { children: (_d = (_c = paymentProfile === null || paymentProfile === void 0 ? void 0 : paymentProfile.config) === null || _c === void 0 ? void 0 : _c.invoice) === null || _d === void 0 ? void 0 : _d.invoiceDueMessage })] }) })), _jsx("div", __assign({ className: "ta-right" }, { children: _jsxs("small", __assign({ className: "mini m-right-sm faded" }, { children: ["Powered By ", _jsx("i", { className: "fa-kit fa-square-logo" }), " Square"] })) }))] }));
        }
        if (showCheckPO && paymentGroup === paymentType) {
            content = (_jsxs(_Fragment, { children: [content, _jsx(Form.Field, { label: "Number", isRequired: true, id: "checkPONumber", name: "checkPONumber", placeholder: "If Applicable" })] }));
        }
        if (content) {
            return _jsx(Card.Body, { children: content });
        }
        return _jsx(_Fragment, {});
    };
    var renderPaymentIcon = function (paymentGroup) {
        switch (paymentGroup) {
            case squarePaymentTypes.card:
                return _jsx("i", { className: "fas fa-fw fa-credit-card m-left-sm m-right-sm" });
            case squarePaymentTypes.ach:
                return _jsx("i", { className: "fa-solid fa-fw fa-building-columns m-left-sm m-right-sm" });
            case squarePaymentTypes.cashApp:
                return _jsx("i", { className: "fa-kit fa-cashapp-card m-left-sm m-right-sm" });
            case squarePaymentTypes.giftCard:
                return _jsx("i", { className: "fas fa-fw fa-gift-card m-left-sm m-right-sm" });
            case "Cash":
                return _jsx("i", { className: "fas fa-fw fa-money-bill m-left-sm m-right-sm" });
            case "Check":
                return _jsx("i", { className: "fas fa-fw fa-money-check m-left-sm m-right-sm" });
            case squarePaymentTypes.invoice:
                return _jsx("i", { className: "fas fa-fw fa-file-invoice m-left-sm m-right-sm" });
            default:
                return _jsx("i", { className: "fas fa-fw fa-coin m-left-sm m-right-sm" });
        }
    };
    var paymentMethodSelectOptions = Object.keys(widgetPaymentRequest.referenceOrders)
        .map(function (referenceOrder) { return ({
        label: widgetPaymentRequest.referenceOrders[referenceOrder],
        value: "PREVIOUS*".concat(referenceOrder),
    }); })
        .concat(paymentGroups
        .filter(function (p) { return p !== PREVIOUS; })
        .map(function (paymentGroup) { return ({
        label: paymentGroup,
        value: paymentGroup,
    }); }));
    return (_jsxs(_Fragment, { children: [_jsx(InlineError, { closeButton: false, id: "paymentGatewayOutage" }), loadingPayments && !(inlineErrors === null || inlineErrors === void 0 ? void 0 : inlineErrors.paymentGatewayOutage) && (_jsxs(_Fragment, { children: [_jsxs(Row, { children: [_jsx(Col, __assign({ sm: 5 }, { children: _jsx(Skeleton, { variant: "rect", width: "100%", className: "field-skeleton" }) })), _jsx(Col, __assign({ sm: 7 }, { children: _jsx(Skeleton, { variant: "rect", width: "100%", className: "field-skeleton" }) }))] }), _jsxs(Row, { children: [_jsx(Col, __assign({ sm: 7 }, { children: _jsx(Skeleton, { variant: "rect", width: "100%", className: "field-skeleton" }) })), _jsx(Col, __assign({ sm: 5 }, { children: _jsx(Skeleton, { variant: "rect", width: "100%", className: "field-skeleton" }) }))] }), _jsxs(Row, { children: [_jsx(Col, __assign({ sm: 6 }, { children: _jsx(Skeleton, { variant: "rect", width: "100%", className: "field-skeleton" }) })), _jsx(Col, __assign({ sm: 3, xs: 6 }, { children: _jsx(Skeleton, { variant: "rect", width: "100%", className: "field-skeleton" }) })), _jsx(Col, __assign({ sm: 3, xs: 6 }, { children: _jsx(Skeleton, { variant: "rect", width: "100%", className: "field-skeleton" }) }))] }), _jsxs(Row, { children: [_jsx(Col, __assign({ sm: 6 }, { children: _jsx(Skeleton, { variant: "rect", width: "100%", className: "field-skeleton" }) })), _jsx(Col, __assign({ sm: 6 }, { children: _jsx(Skeleton, { variant: "rect", width: "100%", className: "field-skeleton" }) }))] }), _jsx(Row, { children: _jsx(Col, __assign({ sm: 12 }, { children: _jsx(Skeleton, { variant: "rect", width: "100%", className: "field-skeleton" }) })) })] })), iframeSrc && showIframeSrc && (_jsx("iframe", { id: "js-payment-confirm", className: "payment-confirmation-iframe", title: "Brushfire Payment Confirmation", allowTransparency: true, allow: "payment *", src: iframeSrc })), _jsx("div", __assign({ className: "m-bottom-well ".concat(loadingPayments || (inlineErrors === null || inlineErrors === void 0 ? void 0 : inlineErrors.paymentGatewayOutage) || (iframeSrc && showIframeSrc)
                    ? "invisible"
                    : "") }, { children: _jsx(Form, __assign({ initialValues: initialValues, onSubmit: submitOrder, formikBagProps: {
                        submitButtonLabel: widgetPaymentRequest.total < 0
                            ? "Refund: ".concat(intl.formatNumber(widgetPaymentRequest.total, {
                                style: "currency",
                                currency: eventData.currency,
                            }))
                            : paymentType === squarePaymentTypes.invoice
                                ? "Place Order"
                                : "Pay Now",
                        isCheckout: true,
                        isMobile: isMobile,
                        showCashApp: paymentType === squarePaymentTypes.cashApp && !hideCashAppButton,
                        showPlaid: paymentType === squarePaymentTypes.ach,
                    }, validateOnChange: false, validateOnBlur: false, useUnsavedPrompt: false }, { children: function (_a) {
                        var _b, _c, _d;
                        var formikContext = _a.formikContext;
                        var resetForm = function () {
                            setShowPrefilledMessage(false);
                            formikContext.resetForm({ values: { shippingId: null } });
                        };
                        return (_jsxs(WidgetFieldset, __assign({ isDisabled: paymentGroups.length === 0 }, { children: [_jsx(InlineError, { id: "checkoutForm" }), _jsx(FormikContextListener, { currentPath: path, path: activePath, formikContext: formikContext, initialValues: initialValues, active: true }), stripe && widgetPaymentRequest.total > 0 && (_jsx(StripeWalletButton, { stripe: stripe, widgetPaymentRequest: widgetPaymentRequest, setWalletConfirmationPayload: setWalletConfirmationPayloadLocal, setErrorMessage: function (error) {
                                        dispatch(setInlineError({ checkoutForm: error }));
                                    }, eventNumber: eventData.eventNumber.toString() })), _jsx(Form.Input.NameInput, { labelClear: showPrefilledMessage, resetForm: resetForm, isRequired: true, autoComplete: !kioskEnabled }), _jsx(BrushfireField, { id: "".concat(addressField.id), name: "".concat(addressField.id), fieldItem: addressField, currency: currency, autoComplete: !kioskEnabled, defaultCountry: defaultCountry, setDefaultCountry: setDefaultCountry, intl: intl }), _jsxs(Row, { children: [_jsx(Col, __assign({ sm: 6 }, { children: _jsx(Form.Field, { label: "Email", id: "email", name: "email", type: "email", autoComplete: !kioskEnabled ? "email" : "new-off", placeholder: "name@domain.com", isFieldRequired: true }) })), _jsx(Col, __assign({ sm: 6 }, { children: _jsx(Form.Field, { component: Form.Input.Phone, label: "Phone", id: "phone", name: "phone", autoComplete: !kioskEnabled, defaultCountry: defaultCountry, isFieldRequired: true }) }))] }), !kioskEnabled &&
                                    enableSignup &&
                                    isPortal &&
                                    (customerAccount === null || customerAccount === void 0 ? void 0 : customerAccount.email) === undefined &&
                                    (account === null || account === void 0 ? void 0 : account.email) === undefined && (_jsxs("div", __assign({ className: "field" }, { children: [_jsxs("label", __assign({ htmlFor: "password" }, { children: ["Create a password and we'll remember your info for next time! It's fast, easy, and secure! ", _jsx("span", __assign({ className: "optional" }, { children: "- Optional" }))] })), _jsxs(Row, { children: [_jsx(Col, __assign({ xs: 12, md: 6 }, { children: _jsx(Form.Field, { label: "Password", hiddenLabel: true, id: "password", name: "password", type: "password", autoComplete: "new-password", placeholder: "Password", fieldClassName: "" }) })), _jsx(Col, __assign({ xs: 12, md: 6 }, { children: _jsx(Form.Field, { label: "Confirm Password", hiddenLabel: true, id: "confirmPassword", name: "confirmPassword", type: "password", autoComplete: "new-password", placeholder: "Re-type Password", fieldClassName: "" }) }))] })] }))), isUsingSquare ? (_jsx(_Fragment, { children: paymentType !== PREVIOUS && (_jsxs(_Fragment, { children: [_jsx("label", __assign({ className: "m-bottom-sm m-top" }, { children: "Payment Method" })), paymentGroups.length === 0 ? (_jsx(Alert, __assign({ purpose: "danger" }, { children: "There are no Payment Methods configured for this event." }))) : (_jsx(Accordion, __assign({ className: "pill-accordion", defaultActiveKey: paymentGroups[0], activeKey: paymentType }, { children: paymentGroups.map(function (paymentGroup) {
                                                    return (_jsxs(Card, __assign({ className: "".concat(paymentType === paymentGroup ? "active" : "") }, { children: [_jsx(Card.Header, __assign({ onClick: function () {
                                                                    setPaymentType(paymentGroup);
                                                                }, className: "".concat(paymentType === paymentGroup ? "active" : "") }, { children: _jsxs("div", __assign({ className: "field-label-style" }, { children: [renderPaymentIcon(paymentGroup), _jsx("span", __assign({ className: "bold" }, { children: paymentGroup }))] })) })), _jsx(Accordion.Collapse, __assign({ eventKey: paymentGroup }, { children: _jsx(_Fragment, { children: renderPaymentGroup(paymentGroup) }) }))] }), paymentGroup));
                                                }) })))] })) })) : (_jsx(_Fragment, { children: (paymentGroups.length > 1 ||
                                        (paymentGroups.length === 1 &&
                                            ((_c = (_b = paymentMethods.find(function (p) { return p.name === paymentGroups[0]; })) === null || _b === void 0 ? void 0 : _b.infoGrouping) !== null && _c !== void 0 ? _c : "") === "None")) && (_jsxs(_Fragment, { children: [_jsx(HorizontalRule, __assign({ className: "tt-uppercase" }, { children: "Choose Payment Method" })), _jsx(ReactSelect, { options: paymentMethodSelectOptions, name: "allowed-payment-dropdown", value: paymentType
                                                    ? {
                                                        label: paymentType,
                                                        value: paymentType,
                                                    }
                                                    : null, onChange: function (option) {
                                                    if (option.value === undefined) {
                                                        setPaymentType(option.value);
                                                    }
                                                    else {
                                                        if (option.value.includes("PREVIOUS*")) {
                                                            formikContext.setFieldValue("referenceOrderId", option.value.split("*")[1]);
                                                            setPaymentType(PREVIOUS);
                                                        }
                                                        else {
                                                            setPaymentType(option.value);
                                                        }
                                                    }
                                                }, inputId: "paymentType", isDisabled: paymentMethodSelectOptions.length === 1 &&
                                                    Object.keys(widgetPaymentRequest.referenceOrders).length <= 1, isSearchable: false, className: "react-select-container", classNamePrefix: "react-select", "aria-label": "Payment Options", onMenuOpen: function () {
                                                    formikContext === null || formikContext === void 0 ? void 0 : formikContext.setStatus(__assign(__assign({}, formikContext.status), { menuOpen: true }));
                                                }, onMenuClose: function () {
                                                    formikContext === null || formikContext === void 0 ? void 0 : formikContext.setStatus(__assign(__assign({}, formikContext.status), { menuOpen: false }));
                                                } })] })) })), paymentType === PREVIOUS && paymentGroups.length <= 2 && (_jsx(Form.Field, { component: Form.Input.Select, data: Object.keys(widgetPaymentRequest.referenceOrders).map(function (referenceOrder) { return ({
                                        label: widgetPaymentRequest.referenceOrders[referenceOrder],
                                        value: referenceOrder,
                                    }); }), label: "Select Previous Transaction", hiddenLabel: paymentGroups.length > 1, id: "referenceOrderId", name: "referenceOrderId", autoComplete: !kioskEnabled, isFieldRequired: true, disabled: Object.keys(widgetPaymentRequest.referenceOrders).length <= 1 })), !!stripe && (_jsx(FadeSection, __assign({ fade: paymentType === "Card" }, { children: _jsx(Stripe, { id: "payment", name: "payment", label: "Card", setPaymentMethodId: setPaymentMethodId, setError: setCheckoutError, setStripeCardReady: setStripeCardReady }) }))), !gatewaysWithCustomInputs.includes((_d = paymentProfile === null || paymentProfile === void 0 ? void 0 : paymentProfile.gatewayId) !== null && _d !== void 0 ? _d : "") ? (_jsxs(_Fragment, { children: [_jsx(FadeSection, __assign({ fade: paymentType === "Card" }, { children: _jsxs(Row, { children: [_jsx(Col, __assign({ md: 6, xs: 12 }, { children: _jsx(Form.Field, { component: Form.Input.CreditCard, label: "Card Number", id: "card", name: "card", isFieldRequired: true, autoComplete: !kioskEnabled ? "cc-number" : "new-off", receiveCardType: receiveCardType }) })), _jsx(Col, __assign({ md: 3, xs: 6 }, { children: _jsx(MaskedCardExpInput, { id: "exp", name: "exp", label: "Expiration", required: true, autoComplete: !kioskEnabled ? "cc-exp" : "new-off", placeholder: "MM/YY" }) })), _jsx(Col, __assign({ md: 3, xs: 6 }, { children: _jsx(Form.Field, { maxlength: 4, pattern: "\\d*", label: "CVV", isFieldRequired: true, id: "cvv", name: "cvv", autoComplete: !kioskEnabled ? "cc-csc" : "new-off" }) }))] }) })), _jsx(FadeSection, __assign({ fade: paymentType === (eCheck === null || eCheck === void 0 ? void 0 : eCheck.infoGrouping) }, { children: _jsxs(Row, { children: [_jsx(Col, __assign({ md: 6, xs: 12 }, { children: _jsx(Form.Field, { label: "Routing Number", isFieldRequired: true, id: "routingNumber", name: "routingNumber" }) })), _jsx(Col, __assign({ md: 6, xs: 12 }, { children: _jsx(Form.Field, { label: "Account Number", isFieldRequired: true, id: "accountNumber", name: "accountNumber" }) }))] }) })), _jsx(FadeSection, __assign({ fade: showCheckPO }, { children: _jsx(Row, { children: _jsx(Col, __assign({ xs: 12 }, { children: _jsx(Form.Field, { label: "Number", isRequired: true, id: "checkPONumber", name: "checkPONumber", placeholder: "If Applicable" }) })) }) }))] })) : (_jsx(FadeSection, __assign({ fade: showCheckPO && !isUsingSquare }, { children: _jsx(Row, { children: _jsx(Col, __assign({ xs: 12 }, { children: _jsx(Form.Field, { label: "Number", isRequired: true, id: "checkPONumber", name: "checkPONumber", placeholder: "If Applicable" }) })) }) })))] })));
                    } })) }))] }));
};
export default PaymentForm;
